import React, { Component } from 'react'
import { FormControl, Select, MenuItem, TextField } from '@mui/material'
import { faPlus } from '@fortawesome/pro-duotone-svg-icons/faPlus'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'
import { CompactButton } from '@/Components/Elements/StyledComponents/Buttons'

class BlockTabQueries extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tabQueries: this.props.tabQueries ? this.props.tabQueries : [],
        }
    }

    render() {
        const kedo = this.props.kedo
        return (
            <div>
                <h3>{kedo.t('Tab queries')}</h3>
                <CompactButton onClick={this.props.addTabQuery}>
                    <FontAwesomeIcon icon={faPlus} />
                </CompactButton>
                {this.props.tabQueries
                    ? this.props.tabQueries.map((item, index) => (
                          <div key={item.query}>
                              <CompactButton
                                  variant={'error'}
                                  sx={{ float: 'right' }}
                                  onClick={() =>
                                      this.props.deleteTabQuery(index)
                                  }
                              >
                                  <FontAwesomeIcon icon={faTimes} />
                              </CompactButton>
                              <FormControl fullWidth margin="normal">
                                  <FormInputLabel>
                                      {this.props.kedo.t('Query')}
                                  </FormInputLabel>
                                  <Select
                                      value={item.query || ''}
                                      size="small"
                                      displayEmpty
                                      onChange={(e) =>
                                          this.props.onChangeTabQueries(
                                              item,
                                              index,
                                              'query',
                                              e.target.value
                                          )
                                      }
                                  >
                                      <MenuItem value="">
                                          {kedo.t('Choose an option')}
                                      </MenuItem>
                                      {this.props.dossierQueries?.map((dq) => (
                                          <MenuItem key={dq.id} value={dq.id}>
                                              {kedo
                                                  .env()
                                                  .translateItem(
                                                      dq,
                                                      'dossierquery'
                                                  )}
                                          </MenuItem>
                                      ))}
                                  </Select>
                              </FormControl>
                              <FormControl fullWidth margin="normal">
                                  <FormInputLabel>
                                      {this.props.kedo.t('Title')}
                                  </FormInputLabel>
                                  <TextField
                                      size="small"
                                      value={item.title || ''}
                                      onChange={(e) =>
                                          this.props.onChangeTabQueries(
                                              item,
                                              index,
                                              'title',
                                              e.target.value
                                          )
                                      }
                                  />
                              </FormControl>
                          </div>
                      ))
                    : null}
            </div>
        )
    }
}

export default BlockTabQueries
